// src/components/CarLoan.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CarLoan.css";
import Banklist from "../common/Banklist/Banklist";
import Calculator from "../common/calculator";
import LoanForm from "../common/Form/Form";
import ServicesPages from "./ServicesPages";
import Services from "./ServicesPages/Services";
import TestimonialsSection from "../common/testimonials-section";

const CarLoan = () => {
  const navigate = useNavigate();

  return (
    <div className="car-container">
      <section className="lap-hero">
        <div className="lap-container">
          {/* LEFT VIDEO */}
          <div className="lap-video">
            <img
              src="/images/c.png"
              alt="Loan Against Property"
              className="hero-video"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="lap-content">
            <h1>
              Drive Your Dream Car with Easy and Affordable
              <span> Car Loan!</span>
            </h1>

            <ul className="lap-points">
              <li>✔ Quick Loan Approval</li>
              <li>✔ Competitive Interest Rates</li>
              <li>✔ Flexible Repayment Options</li>
            </ul>

            <p>
              Owning your dream car is now easier than ever with our Car Loan
              solutions. Whether you are planning to buy a new or used vehicle,
              we help you get fast approvals, attractive interest rates, and
              minimal documentation. Choose flexible repayment tenures and drive
              home your car without financial stress.
            </p>
          </div>
        </div>
      </section>
      <section className="car-loan-benefits">
        <div className="container">
          <div className="section-titlee">
            <h2>
              Why Choose Krishana Finconcept for Your
              <span> Car Loan?</span>
            </h2>
            <p>
              We make your car ownership journey simple, fast, and hassle-free
              with flexible financing options and quick approvals.
            </p>
          </div>

          <div className="benefits-grid">
            <div className="benefit-card">
              <h4>Affordable Interest Rates</h4>
              <p>
                Get competitive car loan interest rates designed to make your
                EMI payments comfortable.
              </p>
            </div>

            <div className="benefit-card">
              <h4>Zero Foreclosure Charges</h4>
              <p>
                Close your loan early without paying extra penalties or hidden
                fees.
              </p>
            </div>

            <div className="benefit-card">
              <h4>100% Digital Process</h4>
              <p>
                Apply for your car loan online with minimal paperwork and fast
                approvals.
              </p>
            </div>

            <div className="benefit-card">
              <h4>Quick Eligibility Check</h4>
              <p>
                Check your loan eligibility easily without affecting your credit
                score.
              </p>
            </div>

            <div className="benefit-card">
              <h4>Fast Loan Disbursement</h4>
              <p>
                Get your loan amount processed quickly so you can drive your
                dream car sooner.
              </p>
            </div>

            <div className="benefit-card">
              <h4>Flexible EMI Options</h4>
              <p>
                Choose repayment plans and EMIs that match your financial
                comfort.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="homeload-main-section homeloan-section modern-variant unique-hero-design full-width-layout">
        <div className="homeloan-hero-text animated-entrance">
          {/* 1. Badge */}
          <div className="badge-glow animated-item">Drive Your Dream Today</div>

          {/* 2. Main Title */}
          <h1 className="title animated-item">
            Get Behind The Wheel With Our <span>Car Loans!</span>
          </h1>

          {/* 3. Features Pills */}
          <div className="features-flex animated-item">
            <div className="feat-pill">
              <span className="icon">✔</span> Up to 100% On-Road Funding
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Quick & Digital Process
            </div>
            <div className="feat-pill">
              <span className="icon">✔</span> Pocket-Friendly EMIs
            </div>
          </div>

          {/* 4. Description Body */}
          <div className="content-body animated-item">
            <p className="subtitle">
              Turn your aspiration of owning a car into reality with our
              flexible Car Loan services. <strong>Krishana Finconcept</strong>{" "}
              offers financing for both new and pre-owned vehicles with
              attractive interest rates.
            </p>

            <p className="subtitle">
              We understand that buying a car is a milestone. That's why we
              provide tailor-made repayment plans, minimal documentation, and
              speedy approvals so you can drive home your favorite vehicle
              without any delay.
            </p>

            <p className="subtitle">
              From hatchbacks to luxury SUVs, our partnership with top-tier
              banks ensures you get the best deal in the market with transparent
              terms and no hidden charges.
            </p>
          </div>

          {/* 5. Action Button */}
          <div className="cta-wrapper animated-item">
            <button
              className="high-conversion-btn"
              onClick={() => {
                navigate("/services/5", { state: { scrollToApply: true } });
              }}
            >
              <span className="btn-text">Apply For Car Loan</span>
              <div className="btn-glow-shimmer"></div>
            </button>
          </div>
        </div>
      </section>

      <TestimonialsSection />

      <Services
        slug="5"
        title=" Car loan EMI Calculator – Calculate Your Monthly EMI Online
"
      />
    </div>
  );
};

export default CarLoan;
